import * as p from '@clack/prompts'

export async function promptConnectionString(): Promise<string> {
  const input = await p.text({
    message: 'Paste your PostgreSQL connection string',
    placeholder: 'postgres://user:pass@host/db',
    validate(val) {
      const normalized = val?.trim() ?? ''

      if (!normalized) {
        return 'A connection string is required to continue'
      }

      const stripped = normalized.replace(/^['"]|['"]$/g, '')
      if (!stripped.startsWith('postgres://') && !stripped.startsWith('postgresql://')) {
        return 'Must start with postgres:// or postgresql://'
      }
    }
  })

  if (p.isCancel(input)) {
    p.cancel('Setup cancelled.')
    process.exit(0)
  }

  return (input as string).replace(/^['"]|['"]$/g, '').trim()
}
